// #3496 -- a tiny pub/sub between useScoreApi (which sees every successful
// count-changing call, see badgeMutationPolicy.js) and BadgeCountsProvider
// (which refetches the badge counts). Module-level on purpose: useScoreApi is
// called from many components, the provider is mounted once in the shell.
const listeners = new Set();

export function onBadgeAffectingMutation(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitBadgeAffectingMutation(methodName) {
  for (const listener of [...listeners]) {
    try {
      listener(methodName);
    } catch {
      /* a listener must never fail the API call that triggered it */
    }
  }
}
